import Service from './service';

export default class Locale extends Service {

    constructor(options = {}) {
        options.name = 'locale';
        // default base url for locale api
        options.baseURL = process.env.REACT_APP_LOCALE_API_URL;
        super(options);
    }

    // add others methods here...
}